import React, { useCallback, useEffect } from 'react'

import { Grid, Input, Span, CurrencyInput } from 'components'
import { useMovement } from 'hooks'
import { COLORS, FONTS, SPACING, TYPOGRAPHY, FORMAT } from 'utils'

const ValoresContratada = () => {
  const {
    movState,
    setMovState,
    errorsTotalVision,
    setErrorsTotalVision,
    dataAtuacaoInvalida,
    isSomenteCompartilhado,
    isComMobilizacao,
    isSemMobilizacao
  } = useMovement()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMovState((prevState) => ({
      ...prevState,
      visaoTotal: {
        ...prevState.visaoTotal,
        [event.target.name]: event.target.value
      }
    }))
  }

  const handleChangeManual = (name: string, value: string) => {
    setMovState((prevState) => ({
      ...prevState,
      visaoTotal: {
        ...prevState.visaoTotal,
        [name]: value
      }
    }))
  }

  //Ajuste para não exibir justificativa anterior-chamado 889175-1
  useEffect(() => {
    if (
      isSemMobilizacao ||
      !movState.isCompetenciaAtual ||
      dataAtuacaoInvalida
    ) {
      handleChangeManual('txSalBaseJustificativa', '')
      return
    }

    const totalSalarioBase = parseFloat(movState?.visaoTotal?.vlSalBase?.toString())
    const totalFolhaPagamento = parseFloat(movState?.visaoTotal?.vlFolhaPagto?.toString())
    const mesAnteriorEfetivo = parseFloat(movState?.visaoTotal?.qtNeAnterior?.toString())
    const mesAtualEfetivo = parseFloat(movState?.visaoTotal?.qtNeAtual?.toString())
    const mesAnteriorSalario = parseFloat(movState?.visaoTotal?.vlSalBaseAnterior?.toString())
    const mesAnteriorFolha = parseFloat(movState?.visaoTotal?.flPagtoAnterior?.toString()) || 0

    // Limpa a justificativa se as condições não exigem mais ela
    if (
      mesAnteriorEfetivo === mesAtualEfetivo ||
      mesAnteriorSalario !== totalSalarioBase ||
      mesAnteriorFolha !== totalFolhaPagamento
    ) {
      handleChangeManual('txSalBaseJustificativa', '')
    }
  }, [
    movState?.visaoTotal?.vlSalBase,
    movState?.visaoTotal?.vlFolhaPagto,
    movState?.visaoTotal?.qtNeAnterior,
    movState?.visaoTotal?.qtNeAtual,
    movState?.visaoTotal?.vlSalBaseAnterior,
    movState?.visaoTotal?.flPagtoAnterior,
    isSemMobilizacao,
    movState.isCompetenciaAtual,
    dataAtuacaoInvalida
  ])

  const handleBlockInputValues = useCallback(() => {
    const totalSalarioBase = parseFloat(
      movState?.visaoTotal?.vlSalBase?.toString()
    ) //Total Salário Base
    const totalFolhaPagamento = parseFloat(
      movState?.visaoTotal?.vlFolhaPagto?.toString()
    ) //Total Folha de Pagamento
    const mesAnteriorEfetivo = parseFloat(
      movState?.visaoTotal?.qtNeAnterior?.toString()
    ) //Mês atual Efetivo
    const mesAtualEfetivo = parseFloat(
      movState?.visaoTotal?.qtNeAtual?.toString()
    ) //Mês atual
    const mesAnteriorSalario = parseFloat(
      movState?.visaoTotal?.vlSalBaseAnterior?.toString()
    ) //Mês Anterior
    const mesAnteriorFolha =
      parseFloat(movState?.visaoTotal?.flPagtoAnterior?.toString()) || 0 //Mês Anterior Folha
    if (
      (mesAnteriorEfetivo !== mesAtualEfetivo &&
        mesAnteriorSalario === totalSalarioBase &&
        mesAnteriorFolha === totalFolhaPagamento &&
        !isSomenteCompartilhado) || movState?.visaoTotal?.txSalBaseJustificativa
    ) {
      return false
    }

    if (
      mesAnteriorEfetivo === mesAtualEfetivo &&
      mesAnteriorSalario === totalSalarioBase &&
      mesAnteriorFolha === totalFolhaPagamento
    ) {
      return true
    }
    return true
  }, [
    movState?.visaoTotal?.vlSalBase,
    movState?.visaoTotal?.vlFolhaPagto,
    movState?.visaoTotal?.qtNeAnterior,
    movState?.visaoTotal?.vlSalBaseAnterior,
    movState?.visaoTotal?.flPagtoAnterior
  ])

  const handleErrorsValues = useCallback(() => {
    const totalSalarioBase = parseFloat(
      movState?.visaoTotal?.vlSalBase?.toString()
    ) //Total Salário Base
    const totalFolhaPagamento = parseFloat(
      movState?.visaoTotal?.vlFolhaPagto?.toString()
    ) //Total Folha de Pagamento
    const mesAtualEfetivo = parseFloat(
      movState?.visaoTotal?.qtNeAnterior?.toString()
    ) //Mês atual Efetivo
    const mesAtual = parseFloat(movState?.visaoTotal?.qtNeAtual?.toString()) //Mês atual
    const mesAnteriorSalario = parseFloat(
      movState?.visaoTotal?.vlSalBaseAnterior?.toString()
    ) //Mês Anterior
    const mesAnteriorFolha =
      parseFloat(movState?.visaoTotal?.flPagtoAnterior?.toString()) || 0 //Mês Anterior Folha
    // const mesAnterior = parseFloat(movState?.visaoTotal?.flPagtoAnterior?.toString())
    // const vlHorasExtras = parseFloat(movState?.visaoTotal?.vlHoraExtras.toString())

    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    setErrorsTotalVision((old) => ({
      ...old,
      txSalBaseJustificativa: null,
      vlFolhaPagto: null,
      vlSalBase: null
    }))

    if (
      isComMobilizacao &&
      String(movState.visaoTotal?.vlSalBase) === '0' &&
      movState.flStatusMobilizacao !== '0' &&
      (qtdDeAtivos > 0 ||
        qtdDeAcesso > 0 ||
        qtdDeDemitido > 0 ||
        qtdDeAfastado > 0 ||
        qtdDeTransferido > 0)
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        vlSalBase: {
          message: 'Total Salário Base não pode ser 0'
        }
      }))
    }

    if (String(movState?.visaoTotal?.vlSalBase) === '') {
      setErrorsTotalVision((old) => ({
        ...old,
        vlSalBase: {
          message: 'Campo Obrigatório'
        }
      }))
    }

    const folhaPagamento = Number(movState?.visaoTotal?.vlFolhaPagto)
    const salarioBase = Number(movState?.visaoTotal?.vlSalBase)

    if (
      (!folhaPagamento || folhaPagamento === 0) &&
      isComMobilizacao &&
      (qtdDeAtivos > 0 ||
        qtdDeAcesso > 0 ||
        qtdDeDemitido > 0 ||
        qtdDeAfastado > 0 ||
        qtdDeTransferido > 0)
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        vlFolhaPagto: {
          message: 'Campo Obrigatório'
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        vlFolhaPagto: null
      }))
    }

    if (isComMobilizacao && salarioBase > 0 && folhaPagamento > 0) {
      if (folhaPagamento < salarioBase) {
        setErrorsTotalVision((old) => ({
          ...old,
          vlFolhaPagto: {
            message:
              'O valor Total Folha de Pagamento não pode ser inferior ao valor Total Salário Base!'
          }
        }))
      } else {
        setErrorsTotalVision((old) => ({
          ...old,
          vlFolhaPagto: null
        }))
      }
    }

    if (
      (Number(movState?.visaoTotal?.vlHoraExtras) <= 0 &&
        FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd) > 0) ||
      (Number(movState?.visaoTotal?.vlHoraExtras) <= 0 &&
        FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd) > 0)
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        vlHoraExtras: {
          message: 'Valor da hora extra não pode ser 0.'
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        vlHoraExtras: null
      }))
    }

    if (
      (Number(movState?.visaoTotal?.vlHoraExtras) > 0 &&
        !movState?.visaoTotal?.qtHeQtd) ||
      (Number(movState?.visaoTotal?.vlHoraExtras) > 0 &&
        FORMAT.horasCSNToFloat(movState?.visaoTotal?.qtHeQtd) <= 0)
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: {
          message: 'Quantidade de horas extras não pode ser 0.'
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        qtHeQtd: null
      }))
    }

    //Verificação do valor da folha de pagamento que não pode ser maior que a soma do salário base + horas extras
    const epsilon = 0.00001
    const totalSalarioBaseHorasExtras = parseFloat(movState?.visaoTotal?.vlSalBase?.toString()) + parseFloat(movState?.visaoTotal?.vlHoraExtras?.toString())
    if (folhaPagamento && movState?.visaoTotal?.vlHoraExtras && folhaPagamento > 0 && folhaPagamento < (totalSalarioBaseHorasExtras - epsilon)) {
      setErrorsTotalVision((old) => {
        return {
          ...old,
          vlFolhaPagto: {
            message: 'O valor Total Folha de Pagamento não pode ser inferior ao valor Total Salário Base + Horas Extras!'
          }
        }

      })
    }
    if (
      movState?.visaoTotal?.txSalBaseJustificativa &&
      movState?.visaoTotal?.txSalBaseJustificativa.length < 30
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        txSalBaseJustificativa: {
          message: 'Justificativa mínima de 30 caracteres!'
        }
      }))
    } else if (
      movState?.visaoTotal?.txSalBaseJustificativa &&
      movState?.visaoTotal?.txSalBaseJustificativa.length > 2048
    ) {
      setErrorsTotalVision((old) => ({
        ...old,
        txSalBaseJustificativa: {
          message: 'Justificativa maxima de 2048 caracteres!'
        }
      }))
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        txSalBaseJustificativa: null
      }))
    }
    if (
      mesAtualEfetivo !== mesAtual &&
      mesAnteriorSalario === totalSalarioBase &&
      mesAnteriorFolha === totalFolhaPagamento &&
      !movState?.visaoTotal?.txSalBaseJustificativa &&
      !isSomenteCompartilhado
    ) {
      setErrorsTotalVision((prevState) => ({
        ...prevState,
        txSalBaseJustificativa: {
          message: 'Campo Obrigatório'
        }
      }))
    }
    if (!movState?.isCompetenciaAtual || isSemMobilizacao) {
      setErrorsTotalVision((prevState) => ({
        ...prevState,
        txSalBaseJustificativa: null
      }))
      if (
        (handleBlockInputValues() && !isSomenteCompartilhado) ||
        isSemMobilizacao
      ) {
        handleChangeManual('txSalBaseJustificativa', '')
      }
    }
  }, [
    movState?.visaoTotal?.vlSalBase,
    movState?.visaoTotal?.vlFolhaPagto,
    movState?.visaoTotal?.vlHoraExtras,
    movState?.visaoTotal?.qtHeQtd,
    movState?.visaoTotal?.txSalBaseJustificativa,
    movState?.visaoTotal?.flPagtoAnterior,
    movState?.flStatusMobilizacao
  ]) // retorna uma versão mmemorizada da função que só vai mudar caso um desses valores mudar 

  useEffect(() => {
    handleErrorsValues()
  }, [handleErrorsValues])

  const isDisableInput = (): boolean => {
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    const disableInput = true
    const enableInput = false

    if (
      (qtdDeAtivos > 0 ||
        qtdDeAcesso > 0 ||
        qtdDeDemitido > 0 ||
        qtdDeAfastado > 0 ||
        qtdDeTransferido > 0) && !isSemMobilizacao
    ) {
      return enableInput
    }

    if (
      isSemMobilizacao ||
      !movState.isCompetenciaAtual ||
      dataAtuacaoInvalida ||
      isSomenteCompartilhado ||
      movState?.visaoTotal?.qtTotalEfetivo === 0 ||//incluído com o merge
      movState?.totalEfetivoComDemitidos === 0
    ) {
      return disableInput
    }

    return enableInput
  }

  return (
    <>
      <Span
        marginTop={SPACING.spacing5}
        marginBottom={SPACING.spacing20}
        text="VALORES DE CONTRATADA"
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
        color={COLORS.black}
      />
      <Grid
        gridCols="1fr 1fr 2fr 3.1fr 1fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <CurrencyInput
          value={movState?.visaoTotal?.vlSalBaseAnterior}
          label="Mês Anterior"
          placeholder="R$"
          formValue="vlSalBaseAnterior"
          disabled
        />
        <CurrencyInput
          value={movState?.visaoTotal?.vlSalBase}
          label="Total Salário Base"
          placeholder="R$"
          formValue="vlSalBase"
          required
          onChange={handleChange}
          customError={errorsTotalVision?.vlSalBase}
          disabled={isDisableInput()}
        />
        <div />
        <Input
          value={movState?.visaoTotal?.txSalBaseJustificativa}
          label="Justificativa de Variação"
          placeholder="Justifique"
          formValue="txSalBaseJustificativa"
          required
          onChange={handleChange}
          customError={errorsTotalVision?.txSalBaseJustificativa}
          disabled={
            handleBlockInputValues() ||
            dataAtuacaoInvalida ||
            isSomenteCompartilhado ||
            isSemMobilizacao
          }
        />
      </Grid>
      <Grid gridCols="4fr 3fr 1fr" gridGap="1rem">
        <div></div>
        <Span
          marginTop="-25px"
          marginLeft="10px"
          text="Quantidade de efetivos diferentes entre mês anterior / atual"
          fontSize={TYPOGRAPHY.captionSize12}
          fontWeight={FONTS.light}
          color={COLORS.black}
        />
      </Grid>
      <Grid gridCols="4fr 3fr 1fr" gridGap="1rem">
        <div></div>
        <Span
          marginTop="-2px"
          marginLeft="10px"
          text="Total salário base e total folha de pagamento não podem ser iguais ao mês anterior"
          fontSize={TYPOGRAPHY.captionSize12}
          fontWeight={FONTS.light}
          color={COLORS.black}
        />
      </Grid>
      <Grid
        gridCols="1fr 1fr 6.2fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <CurrencyInput
          value={movState?.visaoTotal?.flPagtoAnterior}
          label="Mês Anterior"
          placeholder="R$"
          formValue="flPagtoAnterior"
          disabled
        />
        <CurrencyInput
          value={movState?.visaoTotal?.vlFolhaPagto}
          label="Total Folha de Pagamento"
          placeholder="R$"
          formValue="vlFolhaPagto"
          required
          onChange={handleChange}
          customError={errorsTotalVision.vlFolhaPagto}
          disabled={isDisableInput()}
        />
      </Grid>
      <Grid
        gridCols="1fr 7.2fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <CurrencyInput
          value={movState?.visaoTotal?.vlHoraExtras}
          onChange={handleChange}
          label="Horas Extras"
          placeholder="R$"
          formValue="vlHoraExtras"
          required
          customError={errorsTotalVision.vlHoraExtras}
          disabled={isDisableInput()}
        />
      </Grid>
    </>
  )
}

export default ValoresContratada
